import { LOOPBACK_HOSTS, safeExternalRedirect } from './redirectSafety';

export const DCC_AUTHORIZE_RESUME_PATH = '/v1/desktop/authorize/resume';
export const DCC_API_HOSTS = ['api.visinvoke.com', 'staging-api.visinvoke.com'];

const CONTINUATION_TOKEN = /^[A-Za-z0-9._~-]{20,4096}$/;

function isLoopback(hostname) {
  return LOOPBACK_HOSTS.includes(String(hostname || '').toLowerCase());
}

export function safeDccContinuation(raw, currentOrigin) {
  const safe = safeExternalRedirect(raw, currentOrigin);
  if (!safe) return null;
  let url;
  try { url = new URL(safe); } catch { return null; }
  if (url.username || url.password || url.hash || url.pathname !== DCC_AUTHORIZE_RESUME_PATH) {
    return null;
  }
  const keys = [...url.searchParams.keys()];
  if (keys.length !== 1 || keys[0] !== 'continuation' || url.searchParams.getAll('continuation').length !== 1) {
    return null;
  }
  const token = url.searchParams.get('continuation') || '';
  if (!CONTINUATION_TOKEN.test(token)) return null;

  if (DCC_API_HOSTS.includes(url.hostname.toLowerCase())) {
    if (url.protocol !== 'https:' || url.port) return null;
  } else if (!isLoopback(url.hostname)) {
    return null;
  }
  return url.toString();
}

export function dccContinuationFromSearch(search, currentOrigin) {
  const raw = new URLSearchParams(search || '').get('redirect');
  return safeDccContinuation(raw, currentOrigin);
}

export function dccContinuationToken(raw, currentOrigin) {
  const safe = safeDccContinuation(raw, currentOrigin);
  return safe ? new URL(safe).searchParams.get('continuation') : null;
}

export function withDccContinuation(path, raw, currentOrigin) {
  const safe = safeDccContinuation(raw, currentOrigin);
  return safe ? path + '?redirect=' + encodeURIComponent(safe) : path;
}

export function registrationGateDestination(registrationOpen, raw, currentOrigin) {
  return registrationOpen ? null : withDccContinuation('/login', raw, currentOrigin);
}
